import React from 'react';
import { makeStyles, Theme } from '@lifeomic/chroma-react/styles';
import SurveyResponseResults, {
  ResponseResult,
} from '../../../Surveys/util/SurveyResponseResults';
import SectionLineItem from './SectionLineItem';
import QuestionLineItem from './QuestionLineItem';

export const useStyles = makeStyles((_theme: Theme) => ({
  root: {},
}));

export type ResponseLineItemOwnProps = {
  lineItem: ResponseResult;
  parentHasScoring: boolean;
  selectedResponse: fhir.QuestionnaireResponse;
  onFavoriteUpdate?: (resource: fhir.QuestionnaireResponse) => void;
};

export type ResponseLineItemProps = ResponseLineItemOwnProps;

const ResponseLineItem: React.FC<ResponseLineItemProps> = props => {
  return SurveyResponseResults.isSectionResult(props.lineItem) ? (
    <SectionLineItem item={props.lineItem} {...props} />
  ) : (
    <QuestionLineItem item={props.lineItem} {...props} />
  );
};

export default React.memo(ResponseLineItem);
